import moment from "moment";

export default value => {
  return moment(value).format("MMM DD YYYY, hh:mm a");
};
